// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3nKdk","rootNoMargin":"styles_rootNoMargin__1D3Bv"};